import clsx from 'clsx';
import { FC, memo } from 'react';

import { useTranslation } from 'react-i18next';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import styles from './empty-orders.module.scss';
import { IEmptyOrdersProps } from './types';

import image from '../../images/empty-favorites.svg';
import { Button, ETitleLevel, Title } from '../ui';

import { useNavigateToMain } from '~utils';

export const EmptyOrders: FC<IEmptyOrdersProps> = memo(({ className = '', ...rest }) => {
  const { t } = useTranslation();

  const { handleNavigateToMainClick } = useNavigateToMain();

  return (
    <div className={clsx(styles.container, className)} {...rest}>
      <LazyLoadImage className={styles.img} src={image} alt={t('alts.not-found') || ''} />
      <Title className={styles.title} level={ETitleLevel.h6}>
        {t('empty-orders.title')}
      </Title>
      <Button
        className={styles.btn}
        text={t('empty-orders.btn')}
        onClick={handleNavigateToMainClick}
      />
    </div>
  );
});
